import styled from 'styled-components';
import Icon from 'js/components/common/Icon';

export default styled(Icon)`
  margin-right: 0.5rem;
`;
